(function () {
    'use strict';

    angular
        .module('comtradeBankingWeb')
        .config(config)
        .run(['$rootScope', '$log', '$location', 'SessionService', 'TimelineService', '$sessionStorage', 'ConfigService', 'ConfigEndpointService', 'Notification', 'HelperService', 'AccountsService',
          function ($rootScope, $log, $location, SessionService, TimelineService, $sessionStorage, ConfigService, ConfigEndpointService, Notification, HelperService, AccountsService) {

                //$rootScope.appGlobalSettings = {};
                // If user is logged, sync data

                //if(ConfigService.authDebug || $sessionStorage.ct_accessToken){
                //  TimelineService.syncTimeline().then(function(response){
                //    console.log("Synced: ");
                //    // $rootScope.$emit('timelineSynced');
                //  }).catch(function(err){
                //    console.log("Error: " + err);
                //  });
                //}

                //$rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams, $httpProvider) {
                //  if(!ConfigService.authDebug && !$sessionStorage.ct_accessToken){
                //    $rootScope.appGlobalSettings.isAuthenticated = false;
                //    SessionService.authorize();
                //  } else {
                //    $rootScope.appGlobalSettings.isAuthenticated = true;
                //  }
                //});

                //initialize Google Analytics
                //$window.ga('create', 'UA-81145963-1', 'auto');

                $rootScope.$on('$stateChangeSuccess',  function  () {
                    //removing numeric values from url paths
                    //                var title = $location.url().substring(1, $location.url().length);
                    //                var urlParts = title.split("/");
                    //                for(var i=0; i<urlParts.length; i++){
                    //                  var match = urlParts[i].match(/\d+/g);
                    //                  if(match){
                    //                    urlParts.splice(i, 1);
                    //                  }
                    //                }
                    //                console.log("UrlParts: " + urlParts);
                    //                var url = "";
                    //                for(var i=0; i<urlParts.length; i++){
                    //                  url = url + "/" + urlParts[i];
                    //                }
                    //                console.log("Url:" + url);
                    ////                title = url.replace('/', "");
                    //                title = url.replace(/\//g, " ");
                    //                console.log("Title:" + title);
                    var gtmObject = HelperService.processUrlForGTM('pageView');

                    var array = gtmObject.title.split(" ");
                    if (array[1] == "accounts" && array[2] != undefined) {
                        var accId = array[2];
                        AccountsService.getAccountById(accId)
                            .then(function (response) {


                                gtmObject.title = array[1] + " - " + response.accountType.group;
                                Notification.clearAll();
                                if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined && window.dataLayer) {
                                    dataLayer.push({
                                        'event': 'virtualPageview',
                                        'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                                        'page': gtmObject.urlWithoutId,
                                        'title': gtmObject.title,
                                        'url': $location.host() + gtmObject.urlWithoutId
                                    });
                                }

                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    } else {

                        Notification.clearAll();
                        //register dataLayer for page tracking
                        if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined && window.dataLayer) {
                            dataLayer.push({
                                'event': 'virtualPageview',
                                'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                                'page': gtmObject.urlWithoutId,
                                'title': gtmObject.titleWithoutId,
                                'url': $location.host() + gtmObject.urlWithoutId
                            });
                        }
                    }
                });

    }]);

    function config($urlRouterProvider, $httpProvider, $locationProvider, NotificationProvider, $compileProvider, ConfigServiceProvider) {
        $httpProvider.interceptors.push('SessionInjectorService');
        $urlRouterProvider.otherwise('/dashboard');
        $httpProvider.defaults.useXDomain = true;
        $httpProvider.defaults.headers.common = {};
        $httpProvider.defaults.headers.post = {};
        $httpProvider.defaults.headers.put = {};
        $httpProvider.defaults.headers.patch = {};

        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common["X-Requested-With"];

        //NOTE: Disabling POST options with this, TODO: Check on IIS
        //$httpProvider.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        //$httpProvider.defaults.headers.common["Accept"] = "*/*";
        $httpProvider.defaults.headers.common["content-type"] = "application/json";

        //$httpProvider.defaults.headers.common['X-User-Agent'] = "MyClient" ;
        //$locationProvider.html5Mode(true).hashPrefix('!');
        $locationProvider.hashPrefix('!');
        //alert(SessionService.accessToken);

        //$sessionStorageProvider.set('ct.accessToken', 'token-something1');

        NotificationProvider.setOptions({
            delay: null,
            startTop: 70,
            startRight: 0,
            verticalSpacing: 20,
            horizontalSpacing: 20,
            positionX: 'center',
            positionY: 'top',
            replaceMessage: null,
            maxCount: null
        });

        if (!ConfigServiceProvider.debugInfoEnabled) {
            $compileProvider.debugInfoEnabled(false);
        }

    }
}());
